// extracted by mini-css-extract-plugin
module.exports = {"container":"TrafficLightWrapper_container__uE2kH"};